import { Component, ComponentInterface, Element, h, Host, Prop, Watch } from '@stencil/core';

interface UiCmsHeadlineBody {
  headline: string;
  isHeadlineCentered?: boolean;
  overline?: string;
  leadtext?: string;
  iconPath?: string;
  headingLevel?: number;
  headingStyle?: number;
}

const headingSizes = { 1: '4xl', 2: '3xl', 3: 'xl', 4: 'lg', 5: 'base' };

@Component({
  tag: 'ui-cms-headline',
  styleUrl: 'ui-cms-headline.scss',
})
export class UiCmsHeadline implements ComponentInterface {
  @Element() el: HTMLElement;

  @Prop({ mutable: true }) body: UiCmsHeadlineBody = {} as any;

  @Prop({ attribute: 'body' }) utilityBody: string;

  @Prop() inverted: boolean;

  @Watch('utilityBody')
  utilityBodyChangeHandler(newValue: string) {
    this.body = newValue ? JSON.parse(newValue) : this.body;
  }

  componentWillLoad() {
    this.utilityBodyChangeHandler(this.utilityBody);
  }

  // Magnolia adds <p> elements when there are line breaks or other formatting spaces in the text.
  // This function removes those <p> elements.
  private stripParagraphTags(html: string): string {
    return html.replace(/<p>/g, '').replace(/<\/p>/g, '<br />');
  }

  render() {
    const { overline, headline, iconPath, isHeadlineCentered, leadtext, headingLevel, headingStyle } = this.body;
    const level = headingLevel || 1;
    const HeadingTag = `h${level}`;
    const headingSize = `sd-headline--size-${headingSizes[headingStyle || level]}`;

    return (
      <Host class={{ centered: isHeadlineCentered }}>
        {overline && <p class={{ overline: true, 'overline--inverted': this.inverted }} innerHTML={overline}></p>}
        <HeadingTag
          class={{
            heading: true,
            'sd-headline': true,
            'sd-headline--inverted': this.inverted,
            'sd-headline--inline': true,
            [headingSize]: true,
          }}
        >
          {iconPath && <sd-icon library={window.ui.cmsState.iconLibrary} name={iconPath}></sd-icon>}
          {headline && <span innerHTML={this.stripParagraphTags(headline)}></span>}
        </HeadingTag>
        {leadtext && (
          <p
            class={{
              'sd-leadtext': true,
              leadtext: true,
              'sd-leadtext--inverted': this.inverted,
            }}
            innerHTML={leadtext}
          ></p>
        )}
      </Host>
    );
  }
}
